// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Logos-module--fadeInAnimation--15c45";
export var logo = "Logos-module--logo--b5920";
export var logosWrapper = "Logos-module--logosWrapper--951c7";